import MarketingManifestView from "../components/entityViews/marketingManifest/MarketingManifestView";

const MarketingManifestPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="marketing-manifest-page">
      <div className="flex-1 min-h-0">
        <MarketingManifestView />
      </div>
    </div>
  );
};

export default MarketingManifestPage;
